import { FeatureGuide } from 'components/new-ui/composed/feature-guide-panel/types';
import { bulkUploadGuide } from 'components/new-ui/composed/feature-guide-panel/guides/bulkUploadGuide';
import { customerGuide } from 'components/new-ui/composed/feature-guide-panel/guides/customerGuide';
import { declarationGuide } from 'components/new-ui/composed/feature-guide-panel/guides/declarationGuide';
import { ensFormGuide } from 'components/new-ui/composed/feature-guide-panel/guides/ensFormGuide';
import { formTypeGuide } from 'components/new-ui/composed/feature-guide-panel/guides/formTypeGuide';
import { invoiceGuide } from 'components/new-ui/composed/feature-guide-panel/guides/invoiceGuide';
import { jobGuide } from 'components/new-ui/composed/feature-guide-panel/guides/jobGuide';
import { manifestGuide } from 'components/new-ui/composed/feature-guide-panel/guides/manifestGuide';
import { templateGuide } from 'components/new-ui/composed/feature-guide-panel/guides/templateGuide';
import { StepConfig } from 'components/new-ui/composed/multistep-form/types';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { BrokerUploadFormFields, BrokerUploadSteps } from './types';

/**
 * Guides are derived from the steps that `getBrokerUploadStepsConfig` produced, so the
 * sidebar always matches the form the user is actually looking at. A step may contribute
 * more than one guide - the sidebar pages through them - and a step with no entry
 * contributes none.
 */
export const getBrokerUploadFeatureGuides = (
    steps: StepConfig<BrokerUploadFormFields>[],
    country: DeclarationCountry | undefined,
    type: DeclarationInternalType | undefined
): FeatureGuide[] => {
    const isICS2ENS = country === DeclarationCountry.EU && type === DeclarationInternalType.ENS;

    const guidesByStep: Partial<Record<BrokerUploadSteps, FeatureGuide[]>> = {
        [BrokerUploadSteps.MANIFEST]: [manifestGuide],
        [BrokerUploadSteps.JOB]: [jobGuide],
        [BrokerUploadSteps.CUSTOMER]: [customerGuide],
        [BrokerUploadSteps.DECLARATION]: [declarationGuide],
        [BrokerUploadSteps.FORM_TYPE]: [isICS2ENS ? ensFormGuide : formTypeGuide],
        [BrokerUploadSteps.TEMPLATE]: [templateGuide],
        [BrokerUploadSteps.INVOICE]: [invoiceGuide],
        [BrokerUploadSteps.BULK_UPLOAD]: [bulkUploadGuide],
    };

    return steps.flatMap((step) => {
        const stepKey = step.key as BrokerUploadSteps;
        return (guidesByStep[stepKey] ?? []).map((guide) => ({ ...guide, stepKey }));
    });
};
